import { render, staticRenderFns } from "./MemoDeals.vue?vue&type=template&id=c46b769e&scoped=true&"
import script from "./MemoDeals.vue?vue&type=script&lang=js&"
export * from "./MemoDeals.vue?vue&type=script&lang=js&"
import style0 from "./MemoDeals.vue?vue&type=style&index=0&id=c46b769e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46b769e",
  null
  
)

export default component.exports